// extracted by mini-css-extract-plugin
export default {"HeaderPopup":"HeaderPopup_HeaderPopup__-zjWS"};